// src/client/renderer/shaders/comic-bubble.glsl.ts
//
// Comic-bubble shader GLSL (Plan 14b, Task 2.1).
//
// VERTEX: passthrough — position → gl_Position, uv → vUv. No deformation.
//
// FRAGMENT: polar-coordinate SDF to generate a jagged spiky bubble silhouette.
// Math contract (verbatim from plan §Decision):
//   - Convert vUv to centered [-1,+1] range → (cx, cy)
//   - Compute polar (r, theta) from (cx, cy)
//   - Bubble silhouette boundary: 1.0 - uIrregularity * sin(uSpikes * theta + uTime * 0.5)
//   - Inside silhouette: fill with uColor at uOpacity
//   - Outline: slightly larger silhouette (offset 0.02) rendered in uOutlineColor BEHIND fill
//     (achieved by writing outline colour when r < boundary + 0.02 AND r >= boundary,
//     and fill colour when r < boundary)
//   - Outside both: discard

export const VERTEX = /* glsl */ `
  varying vec2 vUv;
  void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;

export const FRAGMENT = /* glsl */ `
  uniform float uTime;
  uniform vec3  uColor;
  uniform vec3  uOutlineColor;
  uniform float uSpikes;
  uniform float uIrregularity;
  uniform float uOpacity;
  varying vec2  vUv;

  void main() {
    // Map UV [0,1] → centered [-1,+1]
    vec2 uv = vUv * 2.0 - 1.0;

    // Polar coordinates
    float r     = length(uv);
    float theta = atan(uv.y, uv.x);

    // Bubble silhouette boundary (per §Decision math contract)
    float boundary = 1.0 - uIrregularity * sin(uSpikes * theta + uTime * 0.5);
    float outline  = boundary + 0.02;

    if (r > outline) {
      discard;
    } else if (r >= boundary) {
      // Outline band
      gl_FragColor = vec4(uOutlineColor, uOpacity);
    } else {
      // Bubble fill
      gl_FragColor = vec4(uColor, uOpacity);
    }
  }
`;
